import { NavLink, Text } from "@mantine/core";
import { UseNavigateResult } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { type NavEntry } from "~/utils/navManifest";

import { optimisePageTitle } from "../../utils/Helper";
import SvgIcon from "../SvgIcon";

const SidebarItem = ({
  entry,
  isActive,
  navigate,
  hideChevron,
  closeSidebar,
}: {
  entry: NavEntry;
  isActive: boolean;
  navigate: UseNavigateResult<string>;
  hideChevron?: boolean;
  closeSidebar: () => void;
}) => {
  const { t } = useTranslation("common");
  const translatedName = t(`sectionNames.${entry.sectionName}`);
  const optimizedTitle = optimisePageTitle(translatedName);

  return (
    <NavLink
      component="button"
      onClick={() => {
        closeSidebar();
        void navigate({ to: entry.to });
      }}
      active={isActive}
      color="gray"
      label={
        <Text size="sm" fw={600}>
          {optimizedTitle}
        </Text>
      }
      leftSection={<SvgIcon name={entry.icon} />}
      rightSection={!hideChevron ? <SvgIcon name="ChevronRight" /> : undefined}
    />
  );
};

export default SidebarItem;
